<div class="full-img-container">
  <button (click)="closeFullscreenImage()" class="fullscreen-button">
    <i class="fa-solid fa-close fs-1 img-close-icon"></i>
  </button>
  <div class="row position-relative h-100 img-content">
    <img class="case-image p-0" [src]="image?.src" [alt]="image?.src" />
  </div>
</div>
